<div class="lum-login-base" id="lum_login_base">
  <picture class="lum-login-feature" role="presentation"></picture>
  <article class="lum-login-content">
    <router-outlet></router-outlet>

    <footer class="lum-copyright"> © {{ today | date: 'yyyy' }} Luminous </footer>
  </article>
</div>
